import { isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

/** `yyyy-MM-dd` — valid value shape for HTML `<input type="date">`. */
export const HTML_DATE_VALUE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

/**
 * GraphQL `Date` is serialized as Unix milliseconds (see backend `Date` scalar).
 * Backend stores calendar dates as UTC midnight; format in UTC so the UI matches
 * the stored calendar day in every timezone. HTML `<input type="date">` needs `yyyy-MM-dd`.
 */
export function toHtmlDate(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') {
      return '';
    }
    if (HTML_DATE_VALUE_PATTERN.test(trimmed)) {
      return trimmed;
    }
    if (/^\d+$/.test(trimmed)) {
      const dateFromMs = new Date(Number(trimmed));
      if (isValid(dateFromMs)) {
        return formatInTimeZone(dateFromMs, 'UTC', 'yyyy-MM-dd');
      }
      return '';
    }
    const parsed = new Date(trimmed);
    if (isValid(parsed)) {
      return formatInTimeZone(parsed, 'UTC', 'yyyy-MM-dd');
    }
    return '';
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    const dateFromMs = new Date(value);
    if (isValid(dateFromMs)) {
      return formatInTimeZone(dateFromMs, 'UTC', 'yyyy-MM-dd');
    }
    return '';
  }

  return '';
}
